// All bilingual content for Wosol Tech
export const translations = {
  en: {
    nav: {
      home: "Home",
      about: "About",
      services: "Services",
      network: "Networking",
      portfolio: "Portfolio",
      why: "Why Us",
      contact: "Contact",
      cta: "Free Consultation",
      whatsapp: "Contact via WhatsApp",
    },
    hero: {
      eyebrow: "Wosol Tech // Integrated Technology",
      headline_1: "Your Path to the",
      headline_2: "Future",
      headline_3: "Starts Here.",
      sub: "We engineer integrated technology and networking ecosystems — software, infrastructure, security, cloud, and AI — built to carry your business forward.",
      cta_primary: "Get Free Consultation",
      cta_secondary: "Our Services",
      stat_1: "Years in tech",
      stat_2: "Networks deployed",
      stat_3: "Uptime delivered",
    },
    about: {
      tag: "About Wosol",
      title: "We connect ambition to infrastructure.",
      intro:
        "Wosol Tech is a Middle East–based technology partner focused on digital transformation, enterprise networking, and intelligent systems. We pair clean, performant software with robust LAN/WAN infrastructure — so the systems you build today scale into the future you want tomorrow.",
      vision_title: "Vision",
      vision:
        "To be the most trusted bridge between businesses in the region and the technology that propels them forward.",
      mission_title: "Mission",
      mission:
        "Deliver integrated, secure, and scalable solutions — software, networks, and cloud — engineered with precision and supported with care.",
    },
    services: {
      tag: "Capabilities",
      title: "Services built for serious operators.",
      sub: "Software, networks, security, cloud and AI — under one roof, engineered to talk to each other.",
      cta_card_title: "Need a tailored plan?",
      cta_card_desc: "Tell us your goals — we'll architect the right mix of software, networking, and cloud for you.",
      cta_card_btn: "Talk to an Engineer",
      whatsapp_block_title: "Prefer a quick chat?",
      whatsapp_block_desc: "Reach our team directly on WhatsApp — typically reply within 1 business hour.",
      items: [
        {
          n: "01",
          title: "Web & App Development",
          desc: "High-performance web platforms and mobile apps built on modern stacks, designed for conversion and engineered for scale.",
        },
        {
          n: "02",
          title: "Networking & Infrastructure",
          desc: "LAN/WAN design, structured cabling, switching, routing, Wi‑Fi and data‑center setup with vendor‑grade reliability.",
        },
        {
          n: "03",
          title: "Cybersecurity",
          desc: "Firewalls, endpoint protection, monitoring, hardening and zero‑trust policies that stop incidents before they spread.",
        },
        {
          n: "04",
          title: "Cloud Solutions",
          desc: "Migration, hybrid cloud, IaC, and cost‑optimized architectures across AWS, Azure and GCP.",
        },
        {
          n: "05",
          title: "Automation & AI",
          desc: "RPA, intelligent workflows and applied AI that removes manual work and unlocks operational leverage.",
        },
      ],
    },
    network: {
      tag: "Networking Highlight",
      title: "Networks that don't blink.",
      sub: "From cable to cloud, we design infrastructure that's measured in nines — not in hopes.",
      bullets: [
        {
          title: "Network Design",
          desc: "Topology, segmentation and capacity planning tailored to your traffic patterns.",
        },
        {
          title: "Server Setup",
          desc: "Racks, hypervisors, storage and disaster‑recovery you can actually trust.",
        },
        {
          title: "24/7 Monitoring",
          desc: "Proactive observability with alerting that catches drift before users do.",
        },
        {
          title: "Security Hardening",
          desc: "Defense‑in‑depth: VLANs, firewalls, IDS/IPS and policy automation.",
        },
      ],
    },
    portfolio: {
      tag: "Selected Work",
      title: "Things we've shipped.",
      sub: "A snapshot across web platforms, internal systems, and full‑stack network deployments.",
      filters: { all: "All", web: "Websites", systems: "Systems", network: "Networks" },
      items: [
        {
          cat: "web",
          name: "Commerce Platform",
          tag: "E‑commerce / Web",
        },
        {
          cat: "systems",
          name: "Operations Console",
          tag: "Internal System",
        },
        {
          cat: "network",
          name: "Enterprise LAN Rollout",
          tag: "Networking",
        },
        {
          cat: "web",
          name: "Corporate Portal",
          tag: "Web",
        },
        {
          cat: "systems",
          name: "Inventory & POS",
          tag: "Systems",
        },
        {
          cat: "network",
          name: "Datacenter Migration",
          tag: "Networking",
        },
      ],
    },
    why: {
      tag: "Why Wosol",
      title: "Why teams stay with us.",
      items: [
        {
          title: "Integrated Stack",
          desc: "Software, networks and cloud delivered by one accountable partner.",
        },
        {
          title: "High Performance",
          desc: "Engineered for speed — measured, profiled, and tuned end‑to‑end.",
        },
        {
          title: "Security by Default",
          desc: "Hardened baselines and zero‑trust patterns from day one.",
        },
        {
          title: "Built to Scale",
          desc: "Architectures that grow with your traffic and your team.",
        },
        {
          title: "Real Support",
          desc: "Humans on call. SLAs we honor. Postmortems we publish.",
        },
      ],
    },
    contact: {
      tag: "Contact",
      title: "Start today. Stay ahead.",
      sub: "Tell us what you're building. We'll come back with a plan, a path, and a partner.",
      name: "Your name",
      email: "Email address",
      message: "How can we help?",
      submit: "Send message",
      sending: "Sending…",
      success: "Message received. We'll be in touch shortly.",
      error: "Please fill in all fields.",
      info_email: "Email",
      info_phone: "Phone",
      info_location: "Location",
      location_value: "Middle East",
      cta_line: "Start Today. Stay Ahead.",
    },
    footer: {
      tagline: "Bridging ambition and infrastructure.",
      links: "Quick Links",
      follow: "Follow",
      rights: "All rights reserved.",
    },
    common: {
      switch_lang: "العربية",
      lang_short: "AR",
    },
  },

  ar: {
    nav: {
      home: "الرئيسية",
      about: "من نحن",
      services: "خدماتنا",
      network: "الشبكات",
      portfolio: "أعمالنا",
      why: "لماذا نحن",
      contact: "تواصل",
      cta: "استشارة مجانية",
      whatsapp: "تواصل عبر واتساب",
    },
    hero: {
      eyebrow: "Wosol Tech // حلول تقنية متكاملة",
      headline_1: "نصلك إلى",
      headline_2: "المستقبل",
      headline_3: "بثقة.",
      sub: "نُهندس منظومات تقنية وشبكات متكاملة — برمجيات، بنية تحتية، أمن سيبراني، سحابة، وذكاء اصطناعي — مصممة لتدفع أعمالك إلى الأمام.",
      cta_primary: "احصل على استشارة مجانية",
      cta_secondary: "خدماتنا",
      stat_1: "سنوات في التقنية",
      stat_2: "شبكة منفذة",
      stat_3: "وقت تشغيل مضمون",
    },
    about: {
      tag: "عن وصول",
      title: "نربط الطموح بالبنية التحتية.",
      intro:
        "وصول تك شريك تقني من قلب الشرق الأوسط، متخصص في التحول الرقمي وشبكات الشركات والأنظمة الذكية. نُقرن البرمجيات النظيفة وعالية الأداء ببنية تحتية LAN/WAN موثوقة — لكي تنمو الأنظمة التي تبنيها اليوم مع المستقبل الذي تطمح إليه غداً.",
      vision_title: "الرؤية",
      vision:
        "أن نكون الجسر الأكثر موثوقية بين الأعمال في المنطقة والتقنية التي تدفعها إلى الأمام.",
      mission_title: "الرسالة",
      mission:
        "تقديم حلول متكاملة وآمنة وقابلة للتوسع — برمجيات وشبكات وسحابة — مهندسة بدقة ومدعومة بإحترافية.",
    },
    services: {
      tag: "خدماتنا",
      title: "خدمات لمن يأخذ التقنية بجدية.",
      sub: "برمجيات وشبكات وأمن وسحابة وذكاء اصطناعي — تحت سقف واحد، مهندسة لتعمل معاً.",
      cta_card_title: "تحتاج خطة مخصصة؟",
      cta_card_desc: "أخبرنا بأهدافك — ونصمم لك المزيج الصحيح من البرمجيات والشبكات والسحابة.",
      cta_card_btn: "تحدث مع مهندس",
      whatsapp_block_title: "تفضل محادثة سريعة؟",
      whatsapp_block_desc: "تواصل مع فريقنا مباشرة عبر واتساب — رد خلال ساعة عمل عادةً.",
      items: [
        {
          n: "٠١",
          title: "تطوير المواقع والتطبيقات",
          desc: "منصات ويب وتطبيقات جوال عالية الأداء، مصممة للتحويل ومهندسة للنمو.",
        },
        {
          n: "٠٢",
          title: "الشبكات والبنية التحتية",
          desc: "تصميم LAN/WAN، الكابلات المنظمة، السويتشات، الراوترات، الواي‑فاي ومراكز البيانات بموثوقية على مستوى المؤسسات.",
        },
        {
          n: "٠٣",
          title: "الأمن السيبراني",
          desc: "جدران حماية، حماية النقاط الطرفية، مراقبة، تصلب، وسياسات Zero‑Trust توقف الحوادث قبل انتشارها.",
        },
        {
          n: "٠٤",
          title: "الحلول السحابية",
          desc: "ترحيل، سحابة هجينة، بنية تحتية ككود، وتصاميم محسّنة للتكلفة على AWS و Azure و GCP.",
        },
        {
          n: "٠٥",
          title: "الأتمتة والذكاء الاصطناعي",
          desc: "أتمتة العمليات، سير عمل ذكي، وتطبيقات AI تختصر العمل اليدوي وتفتح طاقة تشغيلية حقيقية.",
        },
      ],
    },
    network: {
      tag: "تميّز الشبكات",
      title: "شبكات لا تتوقف.",
      sub: "من الكابل إلى السحابة، نصمم بنية تحتية تُقاس بالتسعات — لا بالأماني.",
      bullets: [
        {
          title: "تصميم الشبكات",
          desc: "هيكلة، تقسيم، وتخطيط سعة مفصّل على أنماط حركة بياناتك.",
        },
        {
          title: "إعداد الخوادم",
          desc: "خزائن، Hypervisors، تخزين، وتعافٍ من الكوارث يمكنك الاعتماد عليه فعلياً.",
        },
        {
          title: "مراقبة 24/7",
          desc: "رصد استباقي وتنبيهات تكتشف الانحرافات قبل أن يلاحظها المستخدمون.",
        },
        {
          title: "تصلب أمني",
          desc: "دفاع متعدد الطبقات: VLANs، جدران حماية، IDS/IPS، وأتمتة السياسات.",
        },
      ],
    },
    portfolio: {
      tag: "أعمال مختارة",
      title: "ما أنجزناه.",
      sub: "لمحة عبر منصات الويب، الأنظمة الداخلية، ونشر الشبكات الكاملة.",
      filters: { all: "الكل", web: "مواقع", systems: "أنظمة", network: "شبكات" },
      items: [
        { cat: "web", name: "منصة تجارة إلكترونية", tag: "تجارة / ويب" },
        { cat: "systems", name: "لوحة عمليات داخلية", tag: "نظام داخلي" },
        { cat: "network", name: "نشر شبكة LAN لمؤسسة", tag: "شبكات" },
        { cat: "web", name: "بوابة شركة", tag: "ويب" },
        { cat: "systems", name: "مخزون ونقاط بيع", tag: "أنظمة" },
        { cat: "network", name: "ترحيل مركز بيانات", tag: "شبكات" },
      ],
    },
    why: {
      tag: "لماذا وصول",
      title: "لماذا تبقى الفرق معنا.",
      items: [
        {
          title: "حزمة متكاملة",
          desc: "برمجيات وشبكات وسحابة من شريك واحد مسؤول.",
        },
        {
          title: "أداء عالٍ",
          desc: "مهندس للسرعة — مقاس، محلل، ومضبوط من الطرف إلى الطرف.",
        },
        {
          title: "أمن من البداية",
          desc: "أساسات مُصلّبة وأنماط Zero‑Trust منذ اليوم الأول.",
        },
        {
          title: "قابلية للتوسع",
          desc: "بنى تنمو مع حركة مستخدميك وفريقك.",
        },
        {
          title: "دعم حقيقي",
          desc: "بشر على الخط. اتفاقيات نلتزم بها. تقارير ما بعد الحوادث ننشرها.",
        },
      ],
    },
    contact: {
      tag: "تواصل معنا",
      title: "ابدأ اليوم. وتقدّم دائماً.",
      sub: "أخبرنا بما تبنيه. سنعود إليك بخطة، ومسار، وشريك.",
      name: "اسمك",
      email: "البريد الإلكتروني",
      message: "كيف يمكننا مساعدتك؟",
      submit: "إرسال الرسالة",
      sending: "جاري الإرسال…",
      success: "تم استلام رسالتك. سنعود إليك قريباً.",
      error: "الرجاء تعبئة جميع الحقول.",
      info_email: "البريد",
      info_phone: "الهاتف",
      info_location: "الموقع",
      location_value: "الشرق الأوسط",
      cta_line: "ابدأ اليوم. وتقدّم دائماً.",
    },
    footer: {
      tagline: "نصل بين الطموح والبنية التحتية.",
      links: "روابط سريعة",
      follow: "تابعنا",
      rights: "جميع الحقوق محفوظة.",
    },
    common: {
      switch_lang: "English",
      lang_short: "EN",
    },
  },
};

export const CONTACT = {
  email: "info@wosol-tech.com",
  phone: "+90 538 034 5542",
  whatsapp: "905380345542",
  whatsappDisplay: "+90 538 034 5542",
};
